import React, { memo } from 'react'

import PageHeadingWrapper from 'wrappers/PageHeadingWrapper'

const PageHeading = (props) => {
  return <PageHeadingWrapper {...props} />
}

export default memo(PageHeading)
